__turbopack_context__.v({
  "button": "AppButton-module-scss-module__b4gJXW__button",
  "hidden": "AppButton-module-scss-module__b4gJXW__hidden",
  "outlinedButton": "AppButton-module-scss-module__b4gJXW__outlinedButton",
  "primaryButton": "AppButton-module-scss-module__b4gJXW__primaryButton",
  "rotation": "AppButton-module-scss-module__b4gJXW__rotation",
  "secondaryButton": "AppButton-module-scss-module__b4gJXW__secondaryButton",
  "spinner": "AppButton-module-scss-module__b4gJXW__spinner",
  "submitButton": "AppButton-module-scss-module__b4gJXW__submitButton",
});
